import { React } from "react";   
const QRcodeWelcomeMessageES = () => {
    return (
        <h4 className="instructions">
            Estimado participante, puede canjear este código QR para convertirse en uno de 
            los primeros probador pilotos de la aplicación GlucoNutris cuando esté operativa, 
            con suerte durante el verano de 2023. Para hacerlo, envíenos una copia de su 
            código QR con correo electrónico haciendo clic en "Contact" en la parte inferior 
            de la pantalla y nos pondremos en contacto con usted en breve. Puede obtener acceso 
            a su código QR iniciando sesión en su cuenta o puede tomar una copia de pantalla 
            y guardarla. Una vez más, gracias por su tiempo. Equipo de GlucoNutris
        </h4>
    )
}
export default QRcodeWelcomeMessageES